import { EditIcon } from '@/assets/icons/edit';
import styled from 'styled-components';
import { themeVar } from '@/styles/theme';

interface PageTitleProps {
  title: string;
  onEditClick?: () => void;
  withBorder?: boolean;
}

export const PageTitle = ({ title, onEditClick, withBorder = true }: PageTitleProps) => {
  return (
    <PageTitleWrap withBorder={withBorder}>
      {title}
      {onEditClick && (
        <IconWrap onClick={onEditClick}>
          <EditIcon fill={themeVar('action.primary')} />
        </IconWrap>
      )}
    </PageTitleWrap>
  );
};

export const PageTitleWrap = styled.div<{ withBorder: boolean }>`
  display: flex;
  align-items: center;
  gap: 20px;
  color: ${themeVar('font.strong')};
  font-family: Blinker;
  font-size: 33px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px;
  background: ${themeVar('layer.1')};
  border-bottom: ${({ withBorder }) => (withBorder ? `1px solid ${themeVar('border.base')}` : 'none')};

  padding: 10px 16px;
  @media (min-width: 600px) {
    padding: 10px 50px;
  }
`;

const IconWrap = styled.div`
  display: flex;
  cursor: pointer;
`;
